import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';
import {InputTextComponent} from '@tisa-group/client-ui/components/inputs/input-text';
import {Icon} from '@tisa-group/client-ui/components/icon';

@Component({
  selector: 'tisa-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['input-password.component.scss', '../input-text/input-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputPasswordComponent extends InputTextComponent {
  passwordHidden = true;

  get passwordIcon(): Icon {
    return this.passwordHidden ? 'eye' : 'eye-crossed';
  }

  @HostBinding(`attr.aria-pressed`)
  get pressedAttribute(): boolean {
    return this.passwordHidden;
  }

  toggleVisibility(): void {
    this.passwordHidden = !this.passwordHidden;
  }
}
